'use client';

import { Suspense, useEffect } from 'react';

import { usePathname, useSearchParams } from 'next/navigation';

function Scrollup() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [pathname, searchParams]);
  return <></>;
}

export default function ResetScrollOnNavigation() {
  return (
    <Suspense fallback={null}>
      <Scrollup />
    </Suspense>
  );
}
